module.exports = __webpack_public_path__ + "336684f303c4ae9af3aae7a9d2f2cb5e.jpg";